export default __webpack_public_path__ + "static/media/camera-rotate.8972d331.svg";